import { ts } from '_core';

import Chart from './chart';

type UniverseTurnoverProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths: Record<string, string>;
  fullScreen: boolean;
  title: string;
  subtitle: string;
  setExternalEmbed: (_json: ts.types.analysis.EmbedChartData) => void;
};

const UniverseTurnover = ({
  id,
  readOnly,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
  subtitle,
  setExternalEmbed,
}: UniverseTurnoverProps) => (
  <Chart
    id={id}
    readOnly={readOnly}
    loadWidgetData={loadWidgetData}
    file={widgetPaths['universe_turnover']}
    fullScreen={fullScreen}
    title={title}
    subtitle={subtitle}
    setExternalEmbed={setExternalEmbed}
  />
);

export default UniverseTurnover;
